module.exports = __webpack_public_path__ + "img/mc-thumb.d44f0808.png";